import { LitElement, html, css } from 'lit';
import { TransformMixin } from './base.js';
import './three-mesh.js';
import './three-geometry.js';

export class ThreeCapsule extends TransformMixin(LitElement) {
  static styles = css`:host { display: contents; }`;

  static properties = {
    args: { type: String },
  };

  constructor() {
    super();
    this.args = '0.5 1 4 8';
  }

  get object3D() {
    const mesh = this.renderRoot?.querySelector?.('three-mesh');
    return mesh ? mesh.object3D : null;
  }

  render() {
    return html`
      <three-mesh
        position=${this.position}
        rotation=${this.rotation}
        scale=${this.scale}
      >
        <three-capsule-geometry slot="geometry" args=${this.args}></three-capsule-geometry>
        <slot name="material" slot="material"></slot>
        <slot></slot>
      </three-mesh>
    `;
  }
}

customElements.define('three-capsule', ThreeCapsule);
